module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/cover-5fd74483ce9306518901c23225de4871.webp";